import React from "react";
import PropTypes from "prop-types";

import { useTheme } from "@mui/material/styles";
import List from "@mui/material/List";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const MiniDrawer = props => {
  const theme = useTheme();
  const { sideDrawerOpen, sideDrawerOpenHandler, children, drawerWidth } = props;

  const paperSx = {
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(sideDrawerOpen
      ? {
          width: drawerWidth,
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }
      : {
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          overflowX: "hidden",
          width: theme.spacing(8) + 1,
          [theme.breakpoints.up("sm")]: {
            width: theme.spacing(11) + 1,
          },
        }),
  };

  return (
    <Drawer variant="permanent" open={sideDrawerOpen} slotProps={{ paper: { sx: paperSx } }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "0 8px",
          ...theme.mixins.toolbar,
        }}
      >
        <IconButton onClick={sideDrawerOpenHandler} size="large">
          {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>
      <Divider />
      <List>{children}</List>
    </Drawer>
  );
};

MiniDrawer.defaultProps = {
  drawerWidth: 240,
};

MiniDrawer.propTypes = {
  sideDrawerOpen: PropTypes.bool.isRequired,
  sideDrawerOpenHandler: PropTypes.func.isRequired,
  children: PropTypes.array.isRequired,
  drawerWidth: PropTypes.number,
};

export default MiniDrawer;
